<template>
  <span class="PaB-money">
    {{dollars}}<span v-if="cents" class="PaB-money__cents">{{cents}}</span>
  </span>
</template>

<script>
export default {
  props: ['amt', 'decimal'],
  computed: {
    dollars: function () {
      const parts = this.amt.split('.')
      return parts[1] || this.decimal ? `${parts[0]}.` : parts[0]
    },
    cents: function () {
      const parts = this.amt.split('.')
      if (this.decimal && !parts[1]) {
        return '00'
      }
      return parts[1] || false
    }
  }
}
</script>

<style lang="scss" scoped>
.PaB-money__cents {
  font-size: 0.6em;
  line-height: 0;
  vertical-align: super;
}
</style>
